module.exports = __webpack_public_path__ + "img/pytemplator.8695d489.svg";